import { useRouterState } from '@tanstack/react-router'
import { useEffect, useRef, useState } from 'react'

export default function RouterProgressBar() {
  const { status } = useRouterState()
  const isPending = status === 'pending'

  const [visible, setVisible] = useState(false)
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    if (isPending) {
      if (hideTimer.current) clearTimeout(hideTimer.current)
      setVisible(true)
    } else {
      hideTimer.current = setTimeout(() => setVisible(false), 400)
    }
    return () => {
      if (hideTimer.current) clearTimeout(hideTimer.current)
    }
  }, [isPending])

  if (!visible) return null

  return (
    <>
      {isPending && (
        <div aria-hidden className="fixed inset-0 z-9998 cursor-wait" />
      )}

      <div
        aria-hidden
        className="fixed top-0 inset-x-0 z-9999 h-[3px] overflow-hidden"
      >
        <div
          className={`h-full transition-opacity duration-400 ${isPending ? 'opacity-100' : 'opacity-0'}`}
          style={{
            background: 'var(--primary-teal, #0d9488)',
            animation: isPending
              ? 'router-progress 1.4s ease infinite'
              : 'none',
            width: '100%',
          }}
        />
        <style>{`
          @keyframes router-progress {
            0%   { transform: translateX(-100%); }
            50%  { transform: translateX(0%); }
            100% { transform: translateX(100%); }
          }
        `}</style>
      </div>
    </>
  )
}
